const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/iam.ts';
import Imm from 'immutable';
import { createSelector } from 'reselect';
import { Logger } from '@cistec/common_web/services/KisLoggerService';
import { IKISAPIAction, ReducerState } from '@cistec/common_web/defs/actionTypes';
import { decCounter, incCounter } from '@cistec/common_web/utils/reducerUtils';
import { LOAD_IAM_TOKEN } from 'App/actions/iam';
import { PatAppStoreState } from './setup/rootReducer';

const Log = Logger('getTokenForIAMReducer');

const initialState = Imm.fromJS({
    loading: 0,

    records: {
        // Maps workId -> record
    },
});

export function iamTokenReducer(state: ReducerState = initialState, action: any = {}) {
    switch (action.type) {
        case LOAD_IAM_TOKEN.pending:
            return getTokenForIAMPending(state, action);
        case LOAD_IAM_TOKEN.success:
            return getTokenForIAMSuccess(state, action);
        case LOAD_IAM_TOKEN.failure:
            return getTokenForIAMFailure(state, action);
    }

    return state;
}

function getTokenForIAMPending(state: ReducerState, _action: IKISAPIAction) {
    return incCounter(state, ['loading']);
}

function getTokenForIAMSuccess(state: ReducerState, action: IKISAPIAction) {
    const list = Imm.fromJS(action.payload || {});
    state = state.setIn(['records'], list);

    return decCounter(state, ['loading']);
}

function getTokenForIAMFailure(state: ReducerState, action: IKISAPIAction) {
    Log.warn(`Failed to load entries: ${action.payload?.returnedValue?.details.Info}`);
    return decCounter(state, ['loading']);
}

export const getTokenForIAMRoot = (state: PatAppStoreState) => state.iamToken.getIn(['records', 'token']);

const emptyMap = Imm.Map<string, any>();

export const getTokenForIAM = createSelector(
    [getTokenForIAMRoot],
    (getTokenForIAM: Imm.Map<string, any>): Imm.Map<string, any> => {
        return (getTokenForIAM ?? emptyMap).get('getTokenForIAM');
    }
);
